import React from 'react'
import { IconAlertTriangle } from '@tabler/icons-react'

import { Banner } from '@/components/banners/Banner'
import { ExternalLink } from '@/components/ExternalLink'

/**
 * A warning for a connection that cannot sync until the customer finishes a step on their side.
 *
 * @param {string} props.heading what the sync is waiting for
 * @param {Array} props.links { url, label } help links, shown under the body
 * @param {React.ReactNode} props.children the body copy
 */
export const SetupBlockedBanner = ({ heading, links, children, ...props }) => (
  <Banner warning icon={<IconAlertTriangle />} {...props}>
    <div className="flex-column small-gap">
      <strong>{heading}</strong>
      <p>{children}</p>
      {links.map((link) => (
        <ExternalLink key={link.url} url={link.url} label={link.label} wrap />
      ))}
    </div>
  </Banner>
)
